import axios from "../utils/axios";

export const createInvoice = async (
  amount,
  currency,
  charityId,
  name,
  email
) => {
  const {
    data: { response, error },
  } = await axios.post(
    `/.netlify/functions/fetch-stripe-invoice`,
    { amount, currency, charityId, name, email },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );

  return { error, response };
};
